<template>
  <div class="mt-2">
    <b-row>
      <b-col cols="2" class="d-flex align-items-center justify-content-end">
        <jalousie-up v-if="hasPosition" class="text-large svg-inline--fa.fa-w-10 svg-inline--fa cursor-pointer" @click.native="setMin" />
        <jalousie-close v-else-if="hasLamel" class="text-large svg-inline--fa.fa-w-10 svg-inline--fa cursor-pointer" @click.native="setMin" />
        <font-awesome-icon v-else :icon="getAdjustIcon" @click="setMin" class="cursor-pointer" />
      </b-col>
      <b-col cols="8" class="d-flex">
        <vue-slider
          ref="slider"
          v-model="value"
          :min="getMin"
          :max="getMax"
          :process="false"
          :clickable="false"
          :disabled="!isConnectionOk"
          :interval="interval"
          @drag-end="dragEnd"
          class="align-self-center w-100"
        />
      </b-col>
      <b-col cols="2" class="text-large d-flex align-items-center justify-content-start">
        <jalousie-down v-if="hasPosition" class="svg-inline--fa.fa-w-10 svg-inline--fa cursor-pointer" @click.native="setMax" />
        <jalousie-open v-else-if="hasLamel" class="svg-inline--fa.fa-w-10 svg-inline--fa cursor-pointer" @click.native="setMax" />
        <font-awesome-icon v-else :icon="getAdjustIcon" @click="setMax" class="cursor-pointer" />
      </b-col>
    </b-row>
    <div v-if="showValue" class="text-center">
      <strong class="text-large">{{ getSingleVar.value }}{{ getSingleVar.unit }}</strong>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/material.css';
import BaseControlMixin from '@/components/controls/mixins/BaseControl';
import NumberControl from '@/components/controls/mixins/NumberControl';
import { mapGetters } from 'vuex';
import JalousieDown from '@/components/icons/design/JalousieDown';
import JalousieClose from '@/components/icons/design/JalousieClose';
import JalousieUp from '@/components/icons/design/JalousieUp';
import JalousieOpen from '@/components/icons/design/JalousieOpen';

export default {
  name: 'Slider',
  mixins: [
    BaseControlMixin,
    NumberControl,
  ],
  data() {
    return {
      sliderValue: this.vars[0].value,
    };
  },
  props: {
    showValue: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters([
      'getActorById',
    ]),
    getActor() {
      return this.getActorById(this.getSingleVar.actorId);
    },
    hasPosition() {
      return this.getActor.argument === 'POSITION';
    },
    hasLamel() {
      return this.getActor.argument === 'LAMELL';
    },
    value: {
      get() {
        return this.getSingleVar.value;
      },
      set(value) {
        this.sliderValue = value;
      },
    },
    getAdjustIcon() {
      return this.getSingleVar.icon ? this.getSingleVar.icon : 'angle-up';
    },
  },
  methods: {
    dragEnd() {
      this.handleControl(this.sliderValue);
    },
    setMin() {
      this.handleControl(this.getMin);
    },
    setMax() {
      this.handleControl(this.getMax);
    },
  },
  components: {
    JalousieOpen,
    JalousieUp,
    JalousieClose,
    JalousieDown,
    VueSlider,
  },
};
</script>

<style lang="scss" scoped>

</style>
